//import ReactGA from 'react-ga4';

//타입폼
const TYPEFORM_VALUE = '1';
const TYPEFORM_PAGE_VIEW = '/consult/typeform';
//const TYPEFORM_EVENT_ACTION = 'consult_typeform';

//카카오톡
const KAKAO_VALUE = '100';
const KAKAO_PAGE_VIEW = '/consult/kakao';
//const KAKAO_EVENT_ACTION = 'consult_kakao';

//알림톡 클릭
const ALIMTALK_CLICK_VALUE = '10000';
const ALIMTALK_CLICK_PAGE_VALUE = '/alimtalk/click';
//const ALIMTALK_CLICK_EVENT_ACTION = 'alimtalk_click';

//알림톡 전송
const ALIMTALK_SEND_VALUE = '1000000';
const ALIMTALK_SEND_PAGE_VALUE = '/alimtalk/send';
//const ALIMTALK_SEND_EVENT_ACTION = 'alimtalk_send';

export const onTypeformClick = (page) => {
  //console.log('onTypeform');
  try {
    //Naver and ACE account
    window.onLogSubmit(TYPEFORM_VALUE);
    window.makeRequest(TYPEFORM_PAGE_VIEW);

    //Google analytics
    //ReactGA.event({
    //  category: page || '',
    //  action: TYPEFORM_EVENT_ACTION,
    //  label: '온라인 문의',
    //});
  } catch (error) {
    console.log(error);
  }
};

export const onKakaoClick = (page) => {
  try {
    //Naver and ACE account
    window.onLogSubmit(KAKAO_VALUE);
    window.makeRequest(KAKAO_PAGE_VIEW);

    //Google analytics
    /* ReactGA.event({
      category: page || '',
      action: KAKAO_EVENT_ACTION,
      label: '카카오 문의',
    }); */
  } catch (error) {
    console.log(error);
  }

  window.open('https://pf.kakao.com/_xeAZsd');
};

export const clickAlimtalk = () => {
  //console.log('onTypeform');
  try {
    //Naver and ACE account
    window.onLogSubmit(ALIMTALK_CLICK_VALUE);
    window.makeRequest(ALIMTALK_CLICK_PAGE_VALUE);

    //Google analytics
    //ReactGA.event({
    //  category: 'click',
    //  action: ALIMTALK_CLICK_EVENT_ACTION,
    //  label: '알림톡 클릭',
    //});
  } catch (error) {
    console.log(error);
  }
};

export const sendAlimtalkLog = () => {
  try {
    //Naver and ACE account
    window.onLogSubmit(ALIMTALK_SEND_VALUE);
    window.makeRequest(ALIMTALK_SEND_PAGE_VALUE);

    //Google analytics
    //ReactGA.event({
    //  category: 'send',
    //  action: ALIMTALK_SEND_EVENT_ACTION,
    //  label: '알림톡 발송',
    //});
  } catch (error) {
    console.log(error);
  }
};
